<div class="work-card flex flex-row gap-16">
  <div>
    <work-ui-icon [name]="iconName()" [theme]="iconTheme()" [fontSize]="26" />
  </div>
  <div>
    <p class="stat-card__label work-text-color-light flex flex-row vertical-center gap-4">
      {{ label() }}
      @if (infoText()) {
        <work-ui-icon [workUiTooltip]="infoText()" [workUiTooltipMaxWidth]="400" class="cursor-help" name="help" [fontSize]="16" />
      }
    </p>
    <p class="stat-card__value work-text-size-h2 work-text-font-bold">{{ value() }}</p>
  </div>
</div>
